import React from 'react';
import _ from 'lodash';
import styled from 'styled-components';
import SchemaTable from './schemaTable';
import SchemaForm from './schemaForm';
import {Tabs as ATabs,Card,Row,Col,Radio,Space,Button,Typography,Breadcrumb as ABreadcrumb,Divider,Dropdown,Empty,Upload,Progress,Modal,Tooltip,Spin,Layout,Alert,Drawer,message,Popover} from 'antd';
import { DownOutlined, UserOutlined,SettingOutlined,ExclamationCircleOutlined  } from '@ant-design/icons';
import { DownloadOutlined, UploadOutlined,SyncOutlined,InfoCircleOutlined } from '@ant-design/icons'; // Import the icons



import MyTable from 'components/table/table';
import New from './new'
import MyChart from './chart'
import {to,showError,waitJob2} from 'utils';
import {useParentState} from 'utils';
import {getInput} from 'components/table/form';
import {FetchDummy as Fetch,PEITFile,PEITGET,PEITDOWNLOAD,PEITTableFile} from 'api';
import {PEITZONE} from 'api'
import {tables,getDefaultLayout} from './schema';
import {excel2json} from './excelOutput'
import PEITgroups from './peitGroups'
import {myvalidate}  from './validateJson';

import Language,{useLanguage} from './language';

import Map from './map'
const MyPopover = ({id,text,placement="right"})=><Popover 
                placement={placement}
                overlayStyle={{maxWidth:300,width:300}} 
                trigger="click"
                content={id?<div><Language id={id}/></div>:<div>{text}</div>
                } 
              >
               <InfoCircleOutlined /> 
              </Popover>
              
const Header=styled.div`
 display: flex;
 flex-direction: row;
 justify-content: flex-end;
 
 padding-bottom: 6px;

`;

const OptionContainer=styled.div`
  display:flex;
  justify-content: flex-end;

`;

const getOnChange=({key,type,format,handleSave})=>{
  return type=="string"&&format=="date"?(e) => handleSave(key, e):
  type=="string"?(e) => handleSave(key, e):  
  type=="number"?(value) => handleSave(key, value):
  type=="boolean"?(e) => handleSave(key, e):
  type=="select"?(value) => handleSave(key, value):
  null
}
const {Title,Text,Paragraph}=Typography;

const Breadcrumb = styled(ABreadcrumb)`
  
  ol {
    display:flex;
    align-items: center;
  }
  
`;
const MyEmpty = styled(Empty)`
  .ant-empty-footer{
    display: flex;
    flex-direction: column;    
    align-items: center;
  }

`;

const MyDiv = styled.div`
   width:400px;
   gap: 40px;
   display: flex;
  flex-direction: column;
  align-items: center;

`;




const generateField = (field, data, handleSave) => {
  
  const { key, type, defaultValue, format, options } = field;
  const value = type==="boolean"?{checked:data?.[key]}:{value:data?.[key]};    
  return getInput({type:type==="string"?"paragraph":type,format,options,key,onChange:getOnChange({key,type,handleSave}),...value})
};

const getItems= ({schema,parent,data,handleSave})=>{
  if(!data)return [];  
  
  const {properties}=schema;    
  
  
  const items = Object.keys(properties).map((key,i)=>(
  {
    key,
    label: <Space>{`${properties[key]?.label ?? key}`}{data[key]?.errors &&<ExclamationCircleOutlined style={{color:"red"}}/>}</Space>,
    children: <RenderComponent {...{schema:properties[key],parent:{value:data,parent}, data:data[key],setData:(value)=>handleSave(key,value)}}/>,
    
  }
  ));  
  return [...items];
};


const SchemaTabs = ({defaultActiveKey,schema,parent,data:_data,setData:_setData}) =>{
  const [data, setData] = useParentState(_data,_setData);
  const handleSave = (fieldName, content) => {
    setData({...data,[fieldName]: content});
  };
  const onChange=(defaultActiveKey)=> setData({...data,defaultActiveKey});
  
  return (<ATabs onChange={onChange} defaultActiveKey={data?.defaultActiveKey} items={getItems({schema,parent,data,handleSave})}/>);
};

export const SchemaCard = ({ schema,parent, data:_data,setData:_setData }) => {
  const [data, setData] = useParentState(_data,_setData);
  // // Handle saving edited content
  const handleSave = (fieldName, content) => {
    setData({...data,[fieldName]: content});
    // if(fieldName=="portAuthority"){
      
    //   const tmpdata = {...data,marine:{...data?.marine,zone:data?.marine?.zone?.filter(o=>o?.id!="default")??[]}}
    //   console.log("CC",tmpdata)
    //   setData({...tmpdata,[fieldName]: content});
    // } else{
    //   setData({...data,[fieldName]: content});
    // }
  };
  
  const inputs = Object.keys(schema.properties).map(key=>({key,...schema.properties[key]}));
  const inputFields = inputs.filter(({type})=>!["object","array"].includes(type));
  const otherFields = inputs.filter(({type})=>["object","array"].includes(type));
  
  // console.log("SchemaCard",data)
  return (
    <Card>
      {inputFields.map(field => (
        <Row key={field.key} gutter={16} style={{ marginBottom: '16px' }}>
          <Col span={10} lg={{ span: 6 }} xl={{ span: 6 }}>
            <span style={{ display: 'block', marginBottom: '8px' }}>{field.label||field.key} {field.info&&<MyPopover text={field.info}/>}:</span>
          </Col>
          <Col span={14} lg={{ span: 18 }} xl={{ span: 18 }}>
            {generateField(field, data, handleSave)}
          </Col>
        </Row>
      ))}
      {otherFields.map(field=>
        <>
        <Title level={3} style={{margin:0}}>{field?.label}</Title>
        {field?.info && <Title level={3} style={{margin:0}}>{field?.info}</Title>}
        <RenderComponent {...{schema:field,parent:{value:data,parent},data:data?.[field.key],setData:(value)=>handleSave(field.key,value)}}/>
        <Divider/>
        </>
      )
      
      }
    </Card>
  );
};


const saveJsonToFile = (name,json) => {
    
    const jsonData = JSON.stringify(json, null, 2);
    const blob = new Blob([jsonData], { type: 'application/json' });
    const url = URL.createObjectURL(blob);

    
    const a = document.createElement('a');
    a.href = url;
    a.download = `${name}.json`;
    document.body.appendChild(a);    
    a.click();    
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };


// 
// One
// 

export const SchemaAgeProfile = ({ schema,parent, data:_data,setData:_setData }) => {
   
   const [data, setData] = useParentState(_data,_setData);  
   const handleSaveName = (fieldName, content) => {
    setData({...data,isSave:true,[fieldName]: content});    
  };
  
    const handleSave = (content) => {    
    
    setData({...data,isSave:true,data: content});    
  };
  
  const ageData =schema.properties['data'];
  
  return (
    <Card 
    style={{padding:12}}
    title={    
      <div style={{padding:12}}>
      <Title level={2} style={{margin:0,paddingBottom: 12,textWrap: "balance"}} editable={{onChange:(value)=>handleSaveName("name",value),text:data?.["name"]}}>{data?.["name"]}</Title>
      <Text type="secondary" editable={{onChange:(value)=>handleSaveName("notes",value),text:data?.["notes"]}}>{data?.["notes"]}</Text>
      </div>
    
    }
    
    >    
      <RenderComponent {...{schema:ageData,parent:{value:data,parent},data:data?.data,setData:(value)=>handleSave(value)}} />           
      
    </Card>
  );
  
}

export const SchemaCardRadio = ({ schema,parent, data:_data,setData:_setData }) => {
  
  
  const [errors, setErrors] = React.useState(); 
  const [data, setData] = useParentState(_data,_setData);  
  // const [radioKey,setRadioKey] = React.useState();
  const [saving,setSaving]=React.useState(false); 
  const [openDrawer, setDrawer]= React.useState(false); 
  // React.useEffect(()=>{setRadioKey(otherFields?.length>0&&otherFields[0]?.key)},[schema])
  
   const {lng="en"} = useLanguage()||{};
  
  const onClose=()=>{
    setDrawer(false)
  }
  
  const {showExtra=true}=schema;
  
  const handleSaveName = (fieldName, content) => {
    setData({...data,isSave:true,[fieldName]: content});    
  };
  const customContent = (data,c)=>{

    
    return (data?.input?.introduction?.portAuthority!=c?.introduction?.portAuthority)?{...c,marine:{...c?.marine??{},zone:c?.marine?.zone.filter(o=>o?.id!="default")}}:c
  }
  const handleSave = (fieldName, content) => {
    
    const obj = fieldName==="input"?{...data,isSave:true,[fieldName]: customContent(data,content)}:{...data,[fieldName]: content};
    setData(obj);
    setErrors();
  };
  const setRadioKey=(radioKey)=>{
    setData({...data,radioKey});
  }
 
  const inputs = Object.keys(schema.properties).map(key=>({key,...schema.properties[key]}));
  const inputFields = inputs.filter(({type})=>!["object","array"].includes(type));
  const otherFields = inputs.filter(({type})=>["object","array"].includes(type));
  
  const handleError=(err)=>{
    setSaving(false);
    return showError(err);
    
  }
  
  const handleButton=async()=>{    
    
    console.log("Response",data);
    const {isValid,errors,tmpData}=myvalidate({...data,output:{}},schema);
    
    if(!isValid){
      setErrors(errors);        
      setData(tmpData);
      
      return
    }
    
    setErrors()
    setSaving(true) 
    
    const [err,response]=await to(PEITFile({id:data?.id,lng,obj:{...data?.input,name:data?.name,notes:data?.notes}}));    
    if(err)return handleError(err);
    setTimeout(()=>{
      setData({...data,isSave:false,radioKey:"output",output:undefined});
      setSaving(false);  
      }, 2000);    
    
    
    
  }
  const saveField = inputFields.find(o=>o.key=="isSave");
  
  
  const radioKey = data?.radioKey ??"input";
  
  const radios=showExtra&&<Space>
    {
    errors?<Alert message={<Button type="text" size="small"><Language id="Error"/></Button>}  type="error" showIcon />://<Alert message={<Button type="text" size="small" onClick={()=> setDrawer(true)}>Error(s)</Button>} type="error" showIcon />:
    // data?.["isSave"] && 
      <>
      <Button type="primary" onClick={handleButton} loading={saving}>{saveField&&saveField?.label}</Button>
      <MyPopover id={"OutputLangDesc"} placement="bottom"/>
      </>
    }
    <Radio.Group value={radioKey}  onChange={(e) => setRadioKey(e.target.value)}>
      {otherFields.map(({key,label,disable})=><Radio.Button key={key} value={key} disabled={!data[key]}>{label||key}</Radio.Button>)}  
    </Radio.Group>
    <ImportExportList name={data?.name} data={data?.input} setData={(o)=>handleSaveName("input",o)} isArray={false} />
    
    </Space>;
  
  
  const field = otherFields.find(o=>o.key==radioKey);
  
  return (
    <Card 
    style={{padding:12}}
    title={    
      <div style={{padding:12}}>
      <Title level={2} style={{margin:0,paddingBottom: 12,textWrap: "balance"}} editable={{onChange:(value)=>handleSaveName("name",value),text:data?.["name"]}}>{data?.["name"]}</Title>
      <Text type="secondary" editable={{onChange:(value)=>handleSaveName("notes",value),text:data?.["notes"]}}>{data?.["notes"]}</Text>
      </div>
    
    }
    extra={radios}
    >    
      {field&&<RenderComponent {...{schema:field,parent:{value:data,parent},data:data?.[field.key],setData:(value)=>handleSave(field.key,value)}} />}
      {<Drawer title="Errors" placement="right" onClose={onClose} open={openDrawer}>
        {JSON.stringify(errors)}
      </Drawer>
      }
    </Card>
  );
};



export const ImportExportList = ({name,data,setData,isArray=true})=>{
  
  const handleMenuClick = (e) => {    
    if(e?.key=="export")return saveJsonToFile(name,data)    
  };
  
  const readFileContent = (file) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      try {
        const jsonData = JSON.parse(e.target.result);
        if(isArray && !Array.isArray(jsonData))return showError("JSON file needs to be an array");
        setData(jsonData);        
      } catch (error) {
        showError(error);
      }
    };
    reader.readAsText(file);
  };
  
  const handleUploadSuccess = (file) =>  readFileContent(file);
  const handleUploadError = (error) => showError(error);
  
    const uploadProps = {
      fileList:[],
      customRequest: ({onSuccess, file }) => {
        handleUploadSuccess(file);
        onSuccess();
        return true;
      },
      onChange: (info) => {
        if (info.file.status === 'error') {
          handleUploadError(info.file.error);
        }
      },
    };
    
   const menuProps = {
    items:[
      {label: 
      <Upload {...uploadProps}>
        {isArray?<Language id="importlist"/>:<Language id="importjson"/>}
      </Upload>
      
      ,key: 'import',disabled:false,icon: <DownloadOutlined />},
      {label: isArray?<Language id="exportlist"/>:<Language id="exportjson"/>,  key: 'export',disabled:false,icon: <UploadOutlined />}
      ],  
    onClick: handleMenuClick,
  };
  
  return (
    <OptionContainer>      
        <Dropdown menu={menuProps} trigger={['click']}>
      <Button type="link">
        <Space>          
          <SettingOutlined  />
        </Space>
      </Button>
    </Dropdown>
    </OptionContainer>
    )
}

const LoadContainer = styled.div`
  display:flex;
  justify-content: center;
  min-height: 120px;
  align-items: center;
`;
const SpinContainer = styled.div`
    display: flex;
    gap: 12px;
    flex-direction: column;
    align-items: center;
`;
const MyHeader = styled.div`
  
  display: flex;
  justify-content: flex-end;
  padding-bottom: 12px

`
const MyBody = styled.div`

`
const MySider = styled.div`

`
const MyDashboard = styled.div`

`

export const SchemaDash = ({ schema,parent, data:_data,setData:_setData }) => {
  const [data, setData] = useParentState(_data,_setData);
  const [loading, setLoading] = React.useState(false);
  // const [error,setError] = React.useState();
  // const [item, setItem] = React.useState();
  const [isRefresh, setRefresh] = React.useState(false);
   const {lng="en"} = useLanguage()||{};
  const {id} = parent.value||{};
  const isCancel = React.useRef()
  
  const onCancel = ()=>{
    isCancel.current=true
    setData({...data,item:{}})
   
     
  }
  
  const {layouts,item,data:output}=data||{};
  
  const handleError=(err)=>{
     setLoading(false)
    // setError(err?.message) 
    
      setData({...data,item:{error:err?.message??undefined}})
      isCancel.current=false
   
  }
  const handleGetStatus = async()=>{    
    setLoading(true)
  
    const [err,item]=await to(waitJob2(()=>PEITGET({id}),(r)=>setData({...data,item:r}),()=>isCancel.current));                
    if(err)return handleError(err)    
    onRefresh(item)
    
  }
  const onRefresh=async(item)=>{      
      // setRefresh(true);
      const [err,binary]=await to(PEITDOWNLOAD(item.url));        
      // setRefresh(false);      
      if(err)return handleError(err)
      const output = excel2json({lng,binary})      
      const filteredData = output.filter(o=>o.SubtanceID!="CO2e")    
      
      setData({...data,item,data:filteredData,layouts:getDefaultLayout()});  
      
      setLoading(false)
  }
  const setLayouts=(layouts)=>{   
    
    setData({...data,layouts});    
  }
  
  const {error,progress,url}=item||{};
  const tryAgain=async()=>{
    // console.log(parent)
    handleError()
    const data=parent?.value;
    const [err,response]=await to(PEITFile({id:data?.id,lng,obj:data?.input}));  
    if(err)return handleError(err.message)
    handleGetStatus();
  }
  
  React.useEffect(()=>{
    if(!data)handleGetStatus()
  },[data])  
 
  // console.log("data",data)  
  
  
  const handleClick=async()=>{      
      window.location = url;      
  }
  return error?
    <Space  direction="vertical" style={{width: "100%",alignItems: "center"}}>
    <Alert
      message=<Language id="Error"/>
      description={error}
      type="error"
      showIcon
    />
    <Button onClick={tryAgain}><Language id="Tryagain"/></Button>
    </Space>
  
  :loading||(progress&&progress!=100)?<LoadContainer>
    {
    progress?<SpinContainer>
        <Progress type="circle" percent={progress} />
        <Typography.Text type="secondary"><Language id="processing"/></Typography.Text>
        <Button onClick={onCancel}><Language id="Cancel"/></Button>
      </SpinContainer>
      :
      <SpinContainer>
        <Spin/>
        <Typography.Text type="secondary"><Language id="submitted"/></Typography.Text>
      </SpinContainer>
    }
  </LoadContainer>:
  output?<div>
    <MyHeader>
       {/*<Tooltip title="Refresh">
        <Button type="link" shape="circle" icon={<SyncOutlined spin={isRefresh}/>} onClick={()=>onRefresh(item)}/>
      </Tooltip>
      */}
     
        {/*<Button type="primary" href={url} target="_blank" > <Language id="download"/> </Button>*/}
        <Space>
         <Tooltip title=<Language id="downloadtooltip"/>>
        <Button type="primary" href={url}> <Language id="download"/> </Button>
        </Tooltip>
        <Popover 
                placement="right" 
                overlayStyle={{maxWidth:300,width:300}} 
                trigger="click"
                content={<div><Language id="OutputResultsDesc"/></div>
                } 
              >
               <InfoCircleOutlined /> 
              </Popover>        
        </Space>
        
      
    </MyHeader>
    <MyBody>
      {output && <MyChart data={output} groups={PEITgroups} lng={lng} layouts={layouts} setLayouts={setLayouts}/>}
    </MyBody>
  </div>
  : <Space  direction="vertical" style={{width: "100%",alignItems: "center"}}>
    <Button type="primary" onClick={tryAgain}><Language id="isSave"/></Button>
    </Space>
  
}

export const SchemaTableBread = ({ schema,parent, data:_data,setData:_setData, id:_id,setId:_setId }) => {
  const [data, setData] = useParentState(_data,_setData);
  // const [id, setId] = React.useState("myid");  
  const [id, setId] = useParentState(_id,_setId);
  const [isVisible, setVisible] = React.useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [defaultZones, setDefaultZones] = React.useState([]);
  
  const loadZones=async()=>{     
    const [err,response]=await to(PEITZONE()) 
    
    return setDefaultZones(response)
  }
   React.useEffect(() => {
    loadZones()    
  },[])
  
   const handleSave = (d) => {     
     
    const otherData = data.filter(item=>item.id!=id);
    const {input:{introduction:{portAuthority}={},marine:{zone:zones=[]}={}}={}} =d;

    // const zone = zones.find(o=>o.id==="default");
    // if(zone?.portAuthority!=portAuthority){
    //   if(portAuthority=="Other"){
    //     _.set(d,"input.marine.zone",zones.filter(o=>o.id!="default"))
    //   } else{
    //   const zone = defaultZones.find(o=>o.id==portAuthority);
    //   const defaultZone = {...zone,id:"default",active:true,portAuthority:portAuthority}
    //   _.set(d,"input.marine.zone",[...zones.filter(o=>o.id!="default"),defaultZone])
    // }
      
    // }
    
    setData([...otherData,d]);
     

     
  
  };
  
  const field = schema.items;
  
  const selectData = data&&data.find(item=>item.id==id);  
  
  
  
  return (
    <>  
     {contextHolder}
    {
    selectData?
    <> 
      <Breadcrumb 
       separator={<span>{">"}</span>}
       items={[{key:"main",title:<Button type="link"><Language id="data"/></Button>,onClick:()=>setId()},{key:id,title:selectData?.name}]}       
      />
     <RenderComponent {...{schema:field,parent:{value:data,parent},data:selectData,setData:handleSave}} />
    </>:
    <>
      <New schema={schema} data={data} {...{isVisible, setVisible}} onFinish={(d)=>{handleSave(d); messageApi.open({        type: 'success',        content: 'Excel file was uploaded'  });}} />
      <ImportExportList name={"PEIT_List"} data={data} setData={setData}/>
    
      
      {!data || data.length==0?
      
      
      <MyEmpty description={false} >
        <MyDiv >
        <Typography.Text type="secondary"> <Language id="nodatalist"/></Typography.Text>
        <Button type="primary" onClick={()=>setVisible(true)}><Language id="createnow"/></Button>
        </MyDiv>
      </MyEmpty>
      :<>
        <Button type="primary" onClick={()=>setVisible(true)}><Language id="new"/></Button>
        
        <SchemaTable 
          showAdd={false}
          showEdit={false} 
          schema={schema} 
          parent={parent} 
          data={data} 
          setData={setData} 
          onEdit={(record)=>setId(record?.id)}
          />
          </>
      }
    </>
    }
    </>
    
  );
};


export const SchemaTableBreadGeneral = ({ schema,parent, data:_data,setData:_setData}) => {
  const [data, setData] = useParentState(_data,_setData);
  
  // console.log("ID",id)
  const [id, setId] = React.useState("myid");  
  const [isVisible, setVisible] = React.useState(false);
   const handleSave = (d) => {      
     const otherData = data.filter(item=>item.id!=id);
    setData([...otherData,d]);
    setVisible(false)
  };
  
  const field = schema.items;
  
  const selectData = data&&data.find(item=>item.id==id);      
  
  const handleOk=()=>{}
  const handleCancel=()=>{setVisible(false)}
  
  return (
    <>  
    {
    selectData?
    <> 
      <Breadcrumb 
       separator={<span>{">"}</span>}
       items={[{key:"main",title:<Button type="link"><Language id="ageProfile"/></Button>,onClick:()=>setId()},{key:id,title:selectData?.name}]}       
      />
     <RenderComponent {...{schema:field,parent:{value:data,parent},data:selectData,setData:handleSave}} />
    </>:
    <>
      <Modal        
          title={""}
          visible={isVisible}
          // onOk={handleOk}
          onCancel={handleCancel}
          maskClosable={false}
          footer={null}
          styles={{body:{paddingTop:24}}}
          // width={800}
        >
        <SchemaForm schema={field} data={data} setData={handleSave} showSubmit={true}/> 
           
      </Modal> 
      
      
      
      {!data || data.length==0?
      
      
      <MyEmpty description={false} >
        <MyDiv >
          <Typography.Text type="secondary"> TODO</Typography.Text>
          <Button type="primary" onClick={()=>setVisible(true)}><Language id="createnow"/></Button>
        </MyDiv>
      </MyEmpty>
      :<>
        <OptionContainer>
        <Button type="primary" onClick={()=>setVisible(true)}><Language id="add"/></Button>
        </OptionContainer>
        <SchemaTable 
          showAdd={false}
          showEdit={false} 
          schema={schema} 
          parent={parent} 
          data={data} 
          setData={setData} 
          onEdit={(record)=>setId(record?.id)}
          />
          </>
      }
    </>
    }
    </>
    
  );
};




export const SchemeTableMap = ({ schema,parent, data:_data,setData:_setData }) => {
  const [data, setData] = useParentState(_data,_setData);
  const [showMap,setShowMap] = React.useState(false)
  

  return<div>
     <Header>
      <Space>
      {/*<Button onClick={()=>setShowMap(!showMap)}>{showMap?"Done":"Modify"}</Button>*/}
      </Space>
     </Header>
     <Map schema={schema} parent={parent} data={data} setData={setData} onFinish={()=>setShowMap(false)}/>
     {/*showMap? <Map schema={schema} data={data} setData={setData} onFinish={()=>setShowMap(false)}/>:
      <SchemaTable schema={schema} parent={parent} data={data} setData={setData} showAdd={false} showEdit={false} directEdit={false}/>
     */}
  </div>
  
}
const MyModal =styled(Modal)`
  .ant-modal-body {
    display: flex;
    flex-direction: column;
    // align-content: center;
    // align-items: center;
  }
`;

export const SchemaPEITTables=({ schema,parent, data:_data,setData:_setData }) => {
  const [data, setData] = useParentState(_data,_setData);
   const [fileList, setFileList] = React.useState([]);
  const [tableID, setTableID] = React.useState();
  const itemId=parent?.parent?.value?.id;
  
  const downloadURL = (url)=>{console.log(url);window.location = url; }
  const columns=[
    {
      title: <Language id="name"/>,
      dataIndex: "id",
      key: "id",      
      visible:true,
       render:(text)=><Space><span>{text}</span><Popover 
                placement="right" 
                overlayStyle={{maxWidth:300,width:300}} 
                trigger="click"
                content={<div><Language id={text}/></div>
                } 
              >
               <InfoCircleOutlined /> 
              </Popover></Space>
    },
    {
      title: <Language id="defaultfile"/>,
      dataIndex: "default",
      key: "default",      
      visible:true,
      render:(url)=><Button type="link" onClick={()=>downloadURL(url)}><Language id="download" /></Button>                    
    },
    {
      title: <Language id="customfile"/>,
      dataIndex: "custom",
      key: "custom",
      
      visible:true,
      render:(url,o)=>url?<Space><Button  onClick={()=>downloadURL(`https://peit-oiep.s3.amazonaws.com/public/input/${url}.csv`)}><Language id="download" /></Button><Button onClick={()=>setTableID(o?.id)}><Language id="edit" /></Button><Button onClick={()=>clearTableId(o?.id)}><Language id="remove"/></Button></Space>:
      <Button disabled={o?.disabled} onClick={()=>setTableID(o?.id)}><Language id="add"/></Button>
    }
    

  ]
  const clearTableId= (tableId)=>{
    const itemIndex = data.findIndex(o => o.id === tableId);
    const item=data.find(o=>o?.id==tableId) || {};
    const newItem = {...item,custom:undefined};
    if (itemIndex !== -1) data[itemIndex] = newItem;   
    
    setData([...data]);        
    setTableID(()=>undefined);  
  }
   const handleDone=()=>{
    const item=data.find(o=>o?.id==tableID) || {};
    const newItem = {...item,custom:`${itemId}/${tableID}`};
    const itemIndex = data.findIndex(o => o.id === tableID);
    if (itemIndex !== -1) data[itemIndex] = newItem;         
    setData([...data]);        
    setTableID(()=>undefined);  
  };
  
  
  const handleCancel=()=>{
    setTableID()
  }
  const onUploadProgress=(file,e)=>{
     const {loaded,total}=e;     
     file.percent=loaded/total*100.0;
     setFileList([file]);
  };
  const handleUpload =async(file)=>{       
    file.status="uploading";
    setFileList([file]);
    
    const [err,response]=await to(PEITTableFile({id:itemId,tableId:tableID,file,onUploadProgress:(e)=>onUploadProgress(file,e)}));    
    if(err){
      file.status="error";
      return setFileList([file]);
    }
    file.status="done";
    setFileList([file]);
    handleDone();
    
  }
   
    
  // console.log("data",data.map(o=>o.custom));
  
  return  <><MyTable 
        rowKey={"id"} 
        columns={columns} 
        data={data} 
        
        showHeader={false}
        rowSelection={false}                 
      />
       <MyModal        
          title={`${tableID} `}
          visible={tableID && true}          
          onCancel={handleCancel}
          maskClosable={false}
          footer={null}
          width={600}
        >
          <Alert showIcon type="info"  message="Note" description={
            <div>
              <Typography.Text><Language id="tableimport1"/></Typography.Text>   
              <ol>
                <li>
                 <Language id="tableimport2"/>
                </li>
                <li>
                 <Language id="tableimport3"/>
                </li>
                <li>
                 <Language id="tableimport4"/>
                </li>
              </ol>
              <Typography.Text><Language id="tableimport5"/></Typography.Text>   
            </div>
            }
      
          />
          <Divider />
          <Upload.Dragger
            name="file"
            accept=".csv"    
            fileList={fileList}
            beforeUpload={ (file) => {
              handleUpload(file)
              return false;
            }}                                 
          >
            <p className="ant-upload-drag-icon">
              <UploadOutlined />
            </p>
            <p className="ant-upload-text"><Language id="uploadmessage"/></p>
            <p className="ant-upload-hint"></p>
          </Upload.Dragger>
           
      </MyModal> 
      </>
      
}



export const RenderComponent=({schema,parent={}, data:_data,setData:_setData,...other})=>{
  const [data, setData] = useParentState(_data,_setData);
  const { meta,type,show } = schema;
  if(show==false)return null;
  
  // console.log(meta,type,parent)
  if (type==="object"){
      if (meta && meta.ui === 'tabs') {
        
        return <SchemaTabs defaultActiveKey={undefined} schema={schema} parent={parent} data={data} setData={setData}/>;
      } else if(meta && meta.ui=="card") {
        // console.log("parent",parent)
        return <SchemaCard schema={schema} parent={parent} data={data} setData={setData}/>;
      } else if(meta && meta.ui=="cardradio") {
        return <SchemaCardRadio schema={schema} parent={parent} data={data} setData={setData}/>;        
      } else if(meta && meta.ui=="ageprofile") {
        return <SchemaAgeProfile schema={schema} parent={parent} data={data} setData={setData}/>;
      } else if(meta && meta.ui=="dash") {
        return <SchemaDash schema={schema} parent={parent} data={data} setData={setData}/>;                  
      } else if (meta && meta.ui === 'editMap') {            
        return <SchemeTableMap schema={schema} parent={parent} data={data} setData={setData} showAdd={false} showEdit={false} directEdit={false}/>
      }      else{
        return <SchemaForm schema={schema} data={data} setData={setData}/>;
      }
    
  } else if (type==="array"){
    
    if (meta && meta.ui === 'bread') {  
      // console.log("BB",parent)
      return <SchemaTableBread schema={schema} parent={parent} data={data} setData={setData} {...other}/>    
    } else if (meta && meta.ui === 'breadGeneral') {
      
      return <SchemaTableBreadGeneral schema={schema} parent={parent} data={data} setData={setData}/>    
     }else if (meta && meta.ui === 'edit') {
      return <SchemaTable schema={schema} parent={parent} data={data} setData={setData} showAdd={false} directEdit={true}/>
     }else if (meta && meta.ui === 'editD') {
      return <SchemaTable schema={schema} parent={parent} data={data} setData={setData} showAdd={true} directEdit={true}/>
    } else if (meta && meta.ui === 'editMap') {            
      return <SchemeTableMap schema={schema} parent={parent} data={data} setData={setData} showAdd={false} showEdit={false} directEdit={false}/>
    } else if (meta && meta.ui === 'tables') {            
      return <SchemaPEITTables schema={schema} parent={parent} data={data ||tables} setData={setData}/>
        
    }else {
      
      return <SchemaTable schema={schema} parent={parent} data={data} setData={setData}/>
    }
  } else {}

  return <div/>;
}

export default RenderComponent;